import request from "@/utils/request";

export const getUserInfo = () =>
  request({
    url: "/EviMember/GetCurrectMember",
    method: "post"
  });

export const updateUserInfo = (data: any) =>
  request({
    url: "/EviMember/Update",
    method: "post",
    data: data
  });

export const login = (data: any) =>
  request({
    url: "/Login/GetJwtToken",
    method: "post",
    data
  });

export const doRefreshToken = (data: any) =>
  request({
    url: "/Login/RefreshToken",
    method: "post",
    data
  });

// export const logout = () =>
//   request({
//     url: "/users/logout",
//     method: "post"
//   });

export const isExistPhone = (phone: any) =>
  request({
    url: "/Register/IsExistPhone",
    method: "post",
    params: { phone: phone }
  });

export const register = (data: any) =>
  request({
    url: "/Register/DoRegister",
    method: "post",
    data
  });

export const updatePassword = (data: any) =>
  request({
    url: "/EviMember/UpdatePassword",
    method: "post",
    data
  });
